import "./styles.scss";

import Dialog from "components/ui/dialog";
import ShareFallback from "components/ui/share-fallback";
import { supportNativeShare } from "components/utils/device";
import PropTypes from "prop-types";
import React, { useState } from "react";

const ShareButton = ({ onClick, onSuccess, onError, onClose, children, title, text, url, smsLink, dialogTitle, dialogSubtitle, buttonTitle, className }) => {
  const [sharePopupOpen, setSharePopupOpen] = useState(false);

  const onCloseSharePopup = () => {
    onClose && onClose();
    setSharePopupOpen(false);
  };

  const openShare = () => {
    onClick && onClick();
    if (supportNativeShare) {
      shareNative();
    } else {
      shareFallback();
    }
  };

  const shareNative = async () => {
    try {
      // eslint-disable-next-line no-undef
      await navigator.share({
        text,
        title,
        url,
      });
      onSuccess && onSuccess();
    } catch (e) {
      onError && onError(e);
    }
  };

  const shareFallback = () => {
    setSharePopupOpen(true);
  };

  const onShareFallbackSuccess = () => {
    onSuccess && onSuccess();
    setSharePopupOpen(false);
  };

  return (
    <>
      <div onClick={openShare} className={`share-button-content ${className}`} tabIndex="0" onKeyDown={(e) => e.key === "Enter" && openShare()} title="Share">
        {children}
      </div>
      <Dialog className="share-popup" open={sharePopupOpen} title={dialogTitle} subtitle={dialogSubtitle} onClose={onCloseSharePopup}>
        <ShareFallback onSuccess={onShareFallbackSuccess} title={title} text={text} url={url} buttonTitle={buttonTitle} smsLink={smsLink} />
      </Dialog>
    </>
  );
};

ShareButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  text: PropTypes.string,
  url: PropTypes.string.isRequired,
  smsLink: PropTypes.string,
  className: PropTypes.string,
  dialogTitle: PropTypes.string,
  dialogSubtitle: PropTypes.string,
  buttonTitle: PropTypes.string,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  onClose: PropTypes.func,
};

ShareButton.defaultProps = {
  onClick: undefined,
  onSuccess: undefined,
  onError: undefined,
  onClose: undefined,
  title: "",
  text: "",
  className: "",
  dialogTitle: "Share",
  dialogSubtitle: "Copy the link and send it yourself or share on your favorite social media platform.",
  buttonTitle: undefined,
};

export default ShareButton;
